import React from 'react';
import './SearchBar.scss';
import { Input } from 'semantic-ui-react';

class SearchBar extends React.Component {
  state = { term: '' };

  onFormSubmit = event => {
    event.preventDefault();
    this.props.onSubmit(this.state.term);
  };

  render() {
    return (
      <form
        onSubmit={this.onFormSubmit}
        onClick={this.onFormSubmit}
        className="ui form"
      >
        <div className="ui action input search-box">
          <Input
            value={this.state.term}
            onChange={e => this.setState({ term: e.target.value })}
            placeholder="Name"
          />
          <button className="ui button">Kindernamen-Suche</button>
        </div>
      </form>
    );
  }
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/Component/SearchBar.js